import React, { useEffect, useRef, useState } from "react";
import api from "../../api";
export default function HealthSendMessage({ onCallInitialized, roomToken, setMessage, message, sendAfterEnter, send, uploadFile, homeButton, agentName, setErrorWebCalling, webCallIdRef, webCallingEnable }) {
  const [file, setFile] = useState(null)
  const [error, setError] = useState(null)
  const fileInputRef = useRef(null);
  const [webCallConnectionUrl, setWebCallConnectionUrl] = useState(null);
  const [isIframeLoaded, setIsIframeLoaded] = useState(false);
  const [showCallIcon, setShowCallIcon] = useState(true)
  const [changeCallIconClr, setChangeCallIconClr] = useState(false)
  const [webCallToken, setWebCallToken] = useState(null)
  const [webPhoneAccessProvided, setWebPhoneAccessProvided] = useState(false)
  const [showToolTip, setShowToolTip] = useState(false)


  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data.message === "HangUp" || event.data.type === "CallHangup") {
        setWebCallConnectionUrl(null)
        setIsIframeLoaded(false)
        setShowCallIcon(true)
        setChangeCallIconClr(false)
        setWebPhoneAccessProvided(false);
      }
      if (event.data.type === "oSipStack" || event.data.type === "oSipSessionRegister") {
        setIsIframeLoaded(true)
        setChangeCallIconClr(true)
      }
      if (event.data.type === 'CallConnected') {
        setShowCallIcon(false)
      }
      if (event.data.type === "WebPhoneAccessProvided" && event.data.WebPhoneAccessProvided) {
        setWebPhoneAccessProvided(true)
      }
    };

    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  useEffect(() => {
    if (webPhoneAccessProvided) {
      getWebCallingPermission();
    }
  }, [webPhoneAccessProvided])

  useEffect(() => {
    if (agentName) {
      setShowToolTip(true);
      const timeout = setTimeout(() => {
        setShowToolTip(false);
      }, 5000);

      return () => clearTimeout(timeout);
    }
  }, [agentName]);

  const requestMicrophoneAccess = async () => {
    try {
      const mediaStream = await navigator.mediaDevices.getUserMedia({ audio: true });
      console.log('Microphone access granted:', mediaStream);
      return mediaStream
    } catch (error) {
      console.error('Error accessing microphone:', error);
      return false;
    }
  };

  const getWebCallingPermission = async () => {
    let response = await api.getWebCallingAuthToken(roomToken);
    if (response && response.result && response.result.connectionUrl && response.result.webCallingToken) {
      setErrorWebCalling(null)
      setWebCallConnectionUrl(response.result.connectionUrl);
      setWebCallToken(response.result.webCallingToken)
    } else {
      setErrorWebCalling("Our Advisor is currently busy! Please try calling after sometime.")
    }
  };

  const handleCallIconClick = async () => {
    setShowToolTip(false)
    const hasMicrophoneAccess = await requestMicrophoneAccess();
    if (hasMicrophoneAccess) {
      getWebCallingPermission();
    } else {
      if (window && window.parent) {
        window.parent.postMessage({ type: "microPhoneRequired", microPhoneRequired: true }, '*')
      }
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      let response = await api.makeWebCall(roomToken, webCallToken);
      if (response && response.result && response.result.callConnected && response.result.callId) {
        webCallIdRef.current = response.result.callId
        let callInitiatedObj = {
          messageId: response.result.callId,
          roomId: response.result?.roomId,
          content: JSON.stringify({
            name: response.result?.agentName || "",
            employeeId: response.result?.agentEmployeeId || "",
            callInitiatedAt: response.result?.callRequestAt || "",
            callProcessing : true
          }),
        }
        onCallInitialized(callInitiatedObj, roomToken)
      }
    }
    if (isIframeLoaded && webCallToken) {
      fetchData();
    }
  }, [isIframeLoaded])
  // const handleFileChange = () => {
  //   fileInputRef.current.value = '';
  // };
  useEffect(() => {
    if (file) {
      for (let doc of file) {
        // if ((doc.size / (1024 * 1024)) > 5) {
        //   fileInputRef.current.value = '';
        //   setError('File size exceeds the maximum limit of 5MB.')
        //   setTimeout(()=>{
        //     setError(null)
        //   },4000)
        //   return
        // }
        uploadFile(file)
        fileInputRef.current.value = '';
      }
    }
  }, [file])
  return (
    <>

      <div class="footerWrap">
        {error ?
          <div style={{ marginLeft: 10, color: "red" }}>{error}</div>
          : null
        }
        <div class="input_text_area">

          <textarea
            value={message}
            style={{ flex: 1 }}
            maxLength={1024}
            // placeholder={"Type your query..."}
            label=""
            required
            onChange={(event) => setMessage(event.currentTarget.value)}
            onKeyDown={(e) => sendAfterEnter(e)}></textarea>
          {message && message.length > 0 ? null : <label className="textAreaPlaceHolder">Type your query...</label>}

          {agentName ?
            <label className="attachment">
              <input ref={fileInputRef} value={file} type={'file'} onChange={(event) => {
                setFile(event.target.files)
                // event.target = null
              }}></input>
            </label>
            : null}
          <div className="send_msg" onClick={send}></div>
        </div>

        {showCallIcon && agentName && webCallingEnable ? <> {!changeCallIconClr ?
        <>
          <div
            className="call_icon"
            onClick={() => handleCallIconClick()}
          >
      
          </div>
          <span className={`popup ${showToolTip ? 'show' : ''}`}>
          <div class="text">Now you can call us directly</div>
          <i class="closeBtn" onClick={() => setShowToolTip(false)}>close</i>
        </span> 
        </>
          : <div class="call_icon disabled"></div>}</> : null}
        {webCallConnectionUrl && (
          <iframe
            src={webCallConnectionUrl}
            allow="microphone"
            style={{ width: 0, height: 0, display: "none", border: "none" }}
            title="Web Calling"
            id="webCallIframe"
          ></iframe>
        )}
      </div>
      {/* <textarea
        value={message}
        style={{ flex: 1 }}
        maxLength={1024}
        // placeholder={disableInput ? "Please select an option... " : "Send a message..."}
        placeholder={"Type your query..."}
        label=""
        // disabled={disableInput}
        required
        onChange={(event) => setMessage(event.currentTarget.value)}
        onKeyDown={(e) => sendAfterEnter(e)}
        
      /> */}
      {/* {showCallIcon && agentName && webCallingEnable ? <> {!changeCallIconClr ?
        <div onClick={() => handleCallIconClick()} class="callback-icon"></div>
        : <div class="callback-icon disabled"></div>}</> : null} */}

      {/* {agentName ?
        <label className="fileInput">
          <input ref={fileInputRef}  value={file} type={'file'} onChange={(event) => {
            setFile(event.target.files)
            // event.target = null
          }}></input>
        </label>
        : null} */}
    
    </>
  );
}
